module.exports = __webpack_public_path__ + "img/d201102-2.70769682.jpg";